export const statuses = {
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected",
}
